module.exports = __webpack_public_path__ + "static/media/fido-passkey-logo.be313f82.png";